import { getDataAPI, postDataAPI, deleteDataAPI, patchDataAPI, putDataAPI } from "../../../helper/api";

export const createClient = (payload) => {
    return postDataAPI("/api/Client/Client", { ...payload })
}

export const updateClient = (payload) => {
    return putDataAPI("/api/Client/Client", { ...payload })
}

export const getAllClient = () => {
    return getDataAPI("/api/Client/Clients")
}

export const getClient = (payload) => {
    return getDataAPI(`/api/Client/Client/${payload}`)
}

export const getClientDetailsByLoginToken = () => {
    return getDataAPI("/api/Client/Client")
}

export const deleteClient = (payload) => {
    return deleteDataAPI(`/api/Client/Client/${payload}`)
}

export const updateClientAccess = (payload) => {
    return patchDataAPI(`/api/Client/UpdateClientAccess/${payload.id}`, { isActive: payload.isActive })
} 